import Slider from 'react-slick'
import styled from 'styled-components'

// this styles fixes a slider bug with width calc
export const StyledSlider = styled(Slider)`
  overflow: hidden;
  min-width: 100%;
  width: 0;
`
